import React from "react";
import { getHoverOptions } from "../../../../generic/Utils/commonUtils";
import ChrComparison from "../../../Reports/templates/ChrComparison";
import { getFormattedNumber } from "../../../../generic/PageUI/Basic/Metric/utils";
import ChrAlert from "../../../../generic/PageUI/Basic/Metric/ChrAlert";

const ChartLegend = (props) => {
  const { basic, name, tooltip, value, hasSecondaryInfo = true } = props;
  if (basic) return `${name} (${value})`;

  const { renderedAsString, previousPeriod, alert = {} } = props;
  const { valueToDisplay } = getFormattedNumber(value);
  return (
    <div className="d-flex flex-gap-10">
      <div className="d-flex flex-gap-15 cui-pie-chart-legend">
        <div
          className="align-self-center truncate-with-ellipsis cui-legend-label"
          { ...getHoverOptions(tooltip || name) }
        >
          { name }
        </div>
        <div className="ml-auto cui-legend-value">
          { valueToDisplay }
        </div>
      </div>
      {
        hasSecondaryInfo && <div className="d-flex custom-width-60-px">
          <ChrAlert {...alert} containerLocator="#cjs-management-report-v2" className="pr-2" renderedAsString={renderedAsString} />
          <div className="ml-auto">
            { previousPeriod && <ChrComparison
              renderedAsString={ renderedAsString }
              changeSentiment={ previousPeriod.insights.sentiment }
              changeValue={ previousPeriod.insights.changeValue }
              changeDirection={ previousPeriod.insights.direction }
              periodOne={{ dateRangeStr: previousPeriod.comparedAgainstPeriod.dateRangeStr, presetStr: previousPeriod.comparedAgainstPeriod.presetStr, value }}
              periodTwo={{ dateRangeStr: previousPeriod.timePeriod.dateRangeStr, presetStr: previousPeriod.timePeriod.presetStr, value: previousPeriod.value }}
            /> }
          </div>
        </div>
      }
    </div>
  );
};

export default ChartLegend;
